import type { DayOfWeek } from 'services/api';

export const WORK_DAYS: { label: string; value: DayOfWeek }[] = [
  {
    label: 'Понедельник',
    value: 'MONDAY',
  },
  {
    label: 'Вторник',
    value: 'TUESDAY',
  },
  {
    label: 'Среда',
    value: 'WEDNESDAY',
  },
  {
    label: 'Четверг',
    value: 'THURSDAY',
  },
  {
    label: 'Пятница',
    value: 'FRIDAY',
  },
  {
    label: 'Суббота',
    value: 'SATURDAY',
  },
];
